<template>
  <div class="customer-info">
    <div class="name" v-if="!isConnectCfg">
      <h1>{{ data.name?data.name: $t('page_extranet_Machine_name') }}</h1>
      <span v-if="userVisibleStatus === 1" class="flag">就绪</span>
      <span v-else-if="userVisibleStatus === 2" class="flag ok">连接中</span>
      <span v-else class="flag err">未就绪</span>
    </div>
    <div class="link-wapper" style="margin-top: 10px">
      <div class="label">
        <span class="title" style="width: 75px;">{{ $t('page_workstation_maintain_name') }}：</span>
        <a-tooltip :title="data.name" placement="topLeft" class="value ellipsis" style="width: calc(100% - 75px);display: flex">
          {{ data.name }}
          <div class="name-conf" v-if="isConnectCfg" style="display: flex;">
            <span v-if="userVisibleStatus === 1" class="flag" style="float:left;height: 21px;margin-top: 3px">就绪</span>
            <span v-else-if="userVisibleStatus === 2" class="flag ok" style="float:left;height: 21px;margin-top: 3px">连接中</span>
            <span v-else class="flag err" style="float:left;height: 21px;margin-top: 3px">未就绪</span>
            <img id="images" v-if="isConnectCfg" :src="data.avatar ? data.avatar : require('@/assets/images/default-device.png')"
                 style="height: 40px;flex-direction: column;padding-left: 10px"/>
          </div>

        </a-tooltip>
      </div>
      <div class="label">
        <span class="title">{{ $t('page_extranet_Machine_SN') }}：</span>
        <a-tooltip v-if="data.gatewayCode" :title="data.gatewayCode" placement="top" class="value ellipsis">
          {{ data.gatewayCode }}
        </a-tooltip>
        <span v-if="!data.gatewayCode" class="value ellipsis"></span>
      </div>
      <template v-if="isMachineTenant || isConnectCfg">

         <div class="label">
          <span class="title">设备序列号：</span>
          <a-tooltip :title="data.factoryNumber" placement="top" class="value ellipsis">{{ data.equipmentSerialNumber }}
          </a-tooltip>
        </div>
        <div class="label">
          <span class="title">类型：</span>
          <a-tooltip :title="data.DeviceType" placement="top" class="value ellipsis">{{ data.type }}</a-tooltip>
        </div>
        <div class="label">
          <span class="title">型号：</span>
          <a-tooltip :title="data.deviceModel" placement="top" class="value ellipsis">{{ data.equipmentModel }}</a-tooltip>
        </div>
        <div class="label">
          <span class="title">所属客户：</span>
          <a-tooltip :title="data.deviceModel" placement="top" class="value ellipsis">{{ data.customerName }}</a-tooltip>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import {getLocalStorage} from "@/utils/storage";

export default {
  name: 'DeviceInfo',
  props: {
    data: {
      type: Object,
      default: null
    },
    isConnectCfg:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tenantClass: 0,
      userVisibleStatus: 0,
      showImg:false,
      imgSrc: '',
    }
  },
  mounted() {
    this.tenantClass = getLocalStorage('USER_INFO')['tenant_classes'];
    this.refreshUserVisibleStatus(this.data);
  },
  computed:{
    isMachineTenant(){
      return this.tenantClass === 4;
    },
    
  },
  methods: {
    refreshUserVisibleStatus(data) {
      return this.userVisibleStatus = data?.userVisibleStatus;
    },
  },
  watch:{
    data:{
      handler(value){
        this.refreshUserVisibleStatus(value);
      },
      deep:true,
    }
  }
}
</script>

<style scoped lang="less">
  .customer-info {
    border-bottom: 1px solid #e9e9e9;

    .name {
      margin-bottom: 16px;
      color: #5395ca;
      font-size: 16px;
      height: 48px;
      width: 100%;
      border-bottom: 1px solid #e9e9e9;

      h1 {
        height: 48px;
        font-size: 16px;
        line-height: 48px;
        color: rgba(0, 0, 0, 0.85);
        display: inline-block;
        margin-bottom: 0;

      }
    }

    .name-conf{
      color: #5395ca;
      font-size: 16px;
      width: 100%;
    }

    .flag {
      padding: 0 4px;
      background-color: #d0edff;
      border-radius: 2px;
      border: solid 1px #4a90e2;
      color: #4a90e2;
      font-size: 10px;
      text-align: center;
      margin-left: 8px;
      display: inline-block;

      &.ok {
        color: #52c41a;
        border-color: #52c41a;
        background-color: #ddffcd;
      }

      &.err {
        color: #f74d55;
        border-color: #f74d55;
        background-color: #fef1f0;
      }
    }

    .link-wapper {
      color: rgba(0, 0, 0, 0.85);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .label {
        width: 32%;
        margin-bottom: 16px;
        display: flex;

        .title {
          width: 105px;
          text-align: right;
        }
      }

      .value {
        color: rgba(0, 0, 0, 0.65);
        width: calc(~"100% - 105px");

        &.offline, &.online, &.err {
          position: relative;
          padding-left: 12px;

          &::before {
            position: absolute;
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #faad14;
            left: 0;
            top: 40%;
          }
        }

        &.online::before {
          background-color: #52c41a;
        }

        &.err::before {
          background-color: #f5222d;
        }
      }
    }
  }
</style>
